"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcFmp = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../utils");
var _index = require("../index");
// 该 js 尽量放在 header[0] 位置

var WH = typeof window === 'undefined' ? 0 : window.innerHeight;
var CHECK_INTERVAL = 500;
var TIME_OUT = 1e4;
var MarkState = {
  START: 'start',
  COMPLETE: 'readyState',
  LOAD: 'load',
  TOUCH: 'touch',
  BEFOREUNLOAD: 'beforeunload'
};
var SCORE_ITEMS = [];
var observer;
// let observerMap = new Map();

function calculateScore(el, tiers, parentScore) {
  try {
    var score = 0;
    var tagName = el.tagName;
    if ("SCRIPT" !== tagName && "STYLE" !== tagName && "META" !== tagName && "HEAD" !== tagName) {
      var childrenLen = el.children ? el.children.length : 0;
      if (childrenLen > 0) {
        for (var child = el.children, len = childrenLen - 1; len >= 0; len--) {
          score += calculateScore(child[len], tiers + 1, score > 0);
        }
      }
      if (score <= 0 && !parentScore) {
        if (!(el.getBoundingClientRect && el.getBoundingClientRect().top < WH)) return 0;
      }
      score += 1 + .5 * tiers;
    }
    return score;
  } catch (error) {}
}
function getFmp(scoreArr) {
  // 过滤掉 score[n] < score[n-1] 的元素
  try {
    for (var n = 1; n < scoreArr.length; n++) {
      if (scoreArr[n].score < scoreArr[n - 1].score) {
        scoreArr.splice(n, 1);
        return getFmp(scoreArr);
      }
    }
    return scoreArr;
  } catch (error) {}
}
var FMPTiming = /*#__PURE__*/function () {
  // perf: any

  function FMPTiming(_ref) {
    var callback = _ref.callback;
    (0, _classCallCheck2.default)(this, FMPTiming);
    (0, _defineProperty2.default)(this, "timer", void 0);
    (0, _defineProperty2.default)(this, "touchEvent", void 0);
    (0, _defineProperty2.default)(this, "observer", void 0);
    (0, _defineProperty2.default)(this, "sendMark", void 0);
    (0, _defineProperty2.default)(this, "imgs", void 0);
    (0, _defineProperty2.default)(this, "mark", void 0);
    (0, _defineProperty2.default)(this, "forbidFmp", void 0);
    (0, _defineProperty2.default)(this, "callback", void 0);
    this.callback = callback;
    // this.muo = MutationObserver;
    this.observer = null;
    this.sendMark = false;
    // this.perf = perf;
    this.imgs = [];
    this.mark = MarkState.START;
    this.initObserver();
  }
  // 禁止发送 fmp, 用于需要手动发的场景, 避免重复发
  // forbidSendFmp() {
  //   return (this.forbidFmp = true)
  // }
  (0, _createClass2.default)(FMPTiming, [{
    key: "supportTiming",
    value: function supportTiming() {
      try {
        if (performance && performance.timing && typeof MutationObserver !== 'undefined') {
          return true;
        } else {
          console.error('WARN: 当前环境不支持 performance API，请忽略！');
          return false;
        }
      } catch (err) {
        // console.error(err)
        return false;
      }
    }
  }, {
    key: "initObserver",
    value: function initObserver() {
      var _this = this;
      try {
        if (!this.supportTiming()) return;
        // 重置状态
        this.resetState();
        // LogInfo('fmp 开始监听元素')
        observer = this.observer = new MutationObserver(function () {
          var time = Date.now() - performance.timing.fetchStart;
          var bodyTarget = document.body;
          if (bodyTarget) {
            var score = 0;
            score += calculateScore(bodyTarget, 1, false);
            SCORE_ITEMS.push({
              score: score,
              t: time
            });
          } else {
            SCORE_ITEMS.push({
              score: 0,
              t: time
            });
          }
        });
        this.observer.observe(document, {
          childList: true,
          subtree: true
        });
        if (document.readyState === "complete") {
          this.mark = MarkState.COMPLETE;
          this.calFinallyScore(); // 如果当前页面状态 dom 准备好了，直接触发 calFinallyScore
        } else {
          window.addEventListener(
          // 页面加载完毕  // 大部分都走 onload 触发
          "load", function () {
            _this.mark = MarkState.LOAD;
            _this.calFinallyScore();
          }, true);
          window.addEventListener(
          // 页面关闭
          'beforeunload', function () {
            _this.mark = MarkState.BEFOREUNLOAD;
            _this.calFinallyScore();
          }, true);
          this.touchEvent = this.listenTouchstart;
          window.addEventListener('touchstart', this.listenTouchstart, true);
        }
      } catch (error) {}
      return this;
    }
  }, {
    key: "listenTouchstart",
    value: function listenTouchstart() {
      // 触摸事件
      var delayTime = 2001;
      try {
        delayTime = Date.now() - performance.timing.fetchStart;
      } catch (error) {}
      if (delayTime > 2000 && this.mark === MarkState.LOAD) {
        // console.log('[@zz-common/lego - logInfo]： listenTouchstart 触发')
        this.mark = MarkState.TOUCH;
        this.calFinallyScore();
        window.removeEventListener('touchstart', this.listenTouchstart, true);
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      observer && observer.disconnect();
      SCORE_ITEMS = [];
      this.timer && clearTimeout(this.timer);
      this.touchEvent && window.removeEventListener('touchstart', this.touchEvent, true);
    }
  }, {
    key: "calFinallyScore",
    value: function calFinallyScore() {
      var _this2 = this;
      try {
        var forbidSend = (0, _index.getForbidSend)();
        // console.log('[@zz-common/lego - logInfo]： calFinallyScore-sendMark', forbidSend);
        if (forbidSend) {
          // 重置状态
          this.resetState();
          return;
        }
        var time = Date.now() - performance.timing.fetchStart;
        var isCheckFmp = time > TIME_OUT // 10秒超时时间
        || SCORE_ITEMS && SCORE_ITEMS.length > 4 && time - (SCORE_ITEMS && SCORE_ITEMS.length && SCORE_ITEMS[SCORE_ITEMS.length - 1].t || 0) > 2 * CHECK_INTERVAL
        // 最少4 个 SCORE_ITEMS 元素  & 当前时间 - 最后一个 SCORE_ITEMS 元素渲染时间差 > 2 * 500 两次 calFinallyScore 执行时间
        // 说明到达了 元素不再变化的时间点
        || SCORE_ITEMS.length > 10 && window.performance.timing.loadEventEnd !== 0 && SCORE_ITEMS[SCORE_ITEMS.length - 1].score === SCORE_ITEMS[SCORE_ITEMS.length - 9].score;
        // SCORE_ITEMS 元素大于 10 个 & load 结束 & SCORE_ITEMS 最后一个元素的分数 为 倒数第9个元素分数 ？？
        // 说明load 结束并且 dom 不再变化

        // console.log('[lego-log] TimeFmp len>4, t > 1000', SCORE_ITEMS && SCORE_ITEMS.length > 4 
        //   && time - (SCORE_ITEMS && SCORE_ITEMS.length && SCORE_ITEMS[SCORE_ITEMS.length - 1].t || 0) > 2 * CHECK_INTERVAL )

        // console.log('[lego-log] TimeFmp len>10, [-9]=[-1] score', (SCORE_ITEMS.length > 10 
        //   && window.performance.timing.loadEventEnd !== 0 
        //   && SCORE_ITEMS[SCORE_ITEMS.length - 1].score === SCORE_ITEMS[SCORE_ITEMS.length - 9].score))

        if (this.observer && isCheckFmp) {
          this.observer.disconnect(); // 取消 MutationObserver
          window.SCORE_ITEMS_CHART = JSON.parse(JSON.stringify(SCORE_ITEMS));
          var fmps = getFmp(SCORE_ITEMS);
          var record = null;
          for (var o = 1; o < fmps.length; o++) {
            if (fmps[o].t >= fmps[o - 1].t) {
              var l = fmps[o].score - fmps[o - 1].score;
              // 计算出分数变化最大时的时间点 record.t = fmps[o].t
              (!record || record.rate <= l) && (record = {
                t: fmps[o].t,
                rate: l
              });
            }
          }
          // 取fmp的时间，默认是30001 大于10s会自动被过滤
          var fmp = record && record.t || 10001;
          try {
            this.checkImgs(document.body);
            var max = Math.max.apply(Math, (0, _toConsumableArray2.default)(this.imgs.map(function (element) {
              if (/^(\/\/)/.test(element)) element = 'https:' + element;
              try {
                var _performance$getEntri;
                return ((_performance$getEntri = performance.getEntriesByName(element)[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.responseEnd) || 0;
              } catch (error) {
                return 0;
              }
            })));
            if (record && record.t > 0 && record.t < 3600000) {
              this.setPerformance({
                fmp: fmp,
                fmpImg: parseInt(Math.max(+record.t, max).toString(), 10) || 0
              });
            } else {
              this.setPerformance({});
            }
            this.timer && clearTimeout(this.timer);
          } catch (error) {
            this.setPerformance({});
            this.timer && clearTimeout(this.timer);
            // console.error(error)
          }
        } else {
          this.timer && clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            _this2.calFinallyScore();
          }, CHECK_INTERVAL);
        }
      } catch (error) {}
    }
  }, {
    key: "checkImgs",
    value: function checkImgs(el) {
      try {
        var tagName = el.tagName;
        if ("SCRIPT" !== tagName && "STYLE" !== tagName && "META" !== tagName && "HEAD" !== tagName) {
          var result = (0, _utils.getImgSrcFromDom)(el);
          if (result) this.imgs.push(result);
          var childLen = el.children ? el.children.length : 0;
          if (childLen > 0) {
            for (var childs = el.children, i = childLen - 1; i >= 0; i--) {
              this.checkImgs(childs[i]);
            }
          }
        }
      } catch (error) {}
    }
  }, {
    key: "setPerformance",
    value: function setPerformance(_ref2) {
      var _ref2$fmp = _ref2.fmp,
        fmp = _ref2$fmp === void 0 ? '30001' : _ref2$fmp,
        _ref2$fmpImg = _ref2.fmpImg,
        fmpImg = _ref2$fmpImg === void 0 ? '30002' : _ref2$fmpImg;
      this.callback({
        value: fmp,
        data: {
          fmp: fmp,
          fmpImg: fmpImg,
          mark: this.mark
        },
        type: 'fmp'
      });
    }
  }]);
  return FMPTiming;
}();
var calcFmp = function calcFmp() {
  return new Promise(function (res) {
    new FMPTiming({
      callback: function callback(data) {
        // LogInfo('FMPTiming', data)
        res(data);
      }
    });
  });
};
exports.calcFmp = calcFmp;